import { canCreateOrUpdate } from './validators/functions/can-create-or-update.function';
import { canPerformAction } from './validators/functions/can-perform-action.function';

export * from './dtos/create-account.dto';
export * from './dtos/account-session.dto';
export * from './dtos/accounts-stats.dto';
export * from './dtos/account-list.dto';
export * from './dtos/account-record.dto';
export * from './dtos/account-search.dto';
export * from './dtos/update-account.dto';

export * from './enums/account-status.enum';
export * from './enums/account-deletion-event-status.enum';
export * from './enums/account-type.enum';
export * from './enums/account-action.enum';

export * from './functions/normalize-handle.function';
export * from './functions/account-status-to-color.function';

export * from './types/accounts-filters';
export * from './types/account-search-filters';

export * from './validators/schemas/create-account.schema';
export * from './validators/schemas/update-account.schema';
export * from './validators/schemas/accounts-search-filters.schema';

export const accountValidators = { canCreateOrUpdate, canPerformAction };
